var EmOnboardingStrings = {
    selection: {
        title: function () { return 'How would you like to get started?'; },
        helperText: function () {
            return "If you are trying to place an order using your credit card, you can directly go to";
        },
        continue: function () { return 'Continue'; },
        quickStart: {
            title: function () { return 'Quick Start'; },
            description: function () { return 'Try placing an order with a one-time budget'; },
            tagText: function () { return 'Fastest'; },
        },
        guidedSetup: {
            title: function () { return 'Guided Setup'; },
            description: function () {
                return 'Set up recurring budgets with advanced configurations';
            },
            tagText: function () { return 'Advanced'; },
        },
    },
    quickStart: {
        title: function () { return 'Quick Start'; },
        description: function () {
            return 'Create a one-time budget that will expire in 24 hours. Members will receive an email with instructions on how to spend the budget.';
        },
        budgetNameField: {
            label: function () { return 'Budget name'; },
            placeholder: function () { return 'Office Lunch'; },
        },
        budgetAmountField: {
            labelUpTo: function (localizedAmountString) {
                return "Amount per person (up to " + localizedAmountString + ")";
            },
            labelDefault: function (currencySymbol) {
                return "Amount per person (" + currencySymbol + ")";
            },
        },
        budgetErrors: {
            budgetNameIsRequired: function () { return 'Budget name is required.'; },
            budgetAmountIsRequired: function () { return 'Budget amount is required.'; },
            budgetAmountShouldBeNumber: function () { return 'Budget amount should be a number.'; },
            budgetAmountLimit: function (amountString) {
                return "Budget limit per person is $" + amountString + ".";
            },
            budgetNotCreatedPleaseTryAgain: function () {
                return 'Budget not created. Please try again.';
            },
        },
        membersSectionTitle: function () { return 'Members'; },
        membersSectionDescription: function () {
            return 'Only you will have access to this one-time budget. You can add more members to this budget later.';
        },
        placeOrder: {
            label: function () { return 'Who will be placing orders?'; },
            singlePlaceOrder: function () { return 'I will place an order for my team'; },
            eachPlaceOrder: function () { return 'Everyone will place their own orders'; },
            pleaseSelectOne: function () { return '*Please select one'; },
        },
        memberField: {
            label: function () { return 'Member Email Addresses'; },
            description: function () {
                return 'Enter the email address of each member separated by commas, newlines, or spaces. You can skip this if you are placing the order for your team.';
            },
        },
        cardNumberField: {
            label: function () { return 'Card Number'; },
            description: function () {
                return 'Your credit card will be only charged when ordering with the above budget.';
            },
        },
        cardExpirationField: {
            label: function () { return 'Card Expiration'; },
        },
        cvcField: {
            label: function () { return 'CVC'; },
        },
        zipCodeField: {
            label: function () { return 'Zip Code'; },
        },
        success: {
            title: function () { return 'You just created your first meal budget!'; },
            description: function () {
                return 'You can now go to doordash.com to place an order. When you check out, you will be able to use the budget created towards your order.';
            },
        },
        needToInviteMoreMembers: {
            title: function () { return 'Need to invite more members?'; },
            description: function () {
                return 'You can invite other employees and grant them access to this budget. They will be able to use this budget to place orders themselves.';
            },
        },
        stillHaveQuestions: {
            title: function () { return 'Still have questions?'; },
            description: function () {
                return 'You can learn more at our Frequently Asked Questions or contact DoorDash for Work support.';
            },
        },
        startOrder: function () { return 'Start Order'; },
        manageEmployees: function () { return 'Manage Employees'; },
        back: function () { return 'Back'; },
        createBudget: function () { return 'Create Budget'; },
    },
};
export default EmOnboardingStrings;
